import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { loginUser, registerUser } from "../../controller/users/usersController";
import errorHandler from "../../utils/errorHandler";
import { addCredObjToLocalStorage, getCredObjFromLocalStorage, removeCredObjsFromLocalStorage } from "../../utils/localStorage";

const initialState = {
  isLoading:false,
  isSideBarOpen:false,
  credObj:getCredObjFromLocalStorage()
};

// export const logoutUser = createAsyncThunk(
//     'user/logoutUser', async (user, thunkAPI) => {
//         try {
//             // const response = await fetchAPI.post('/auth/logout', user); TODO
//             let loggedOut = {success: true}
//             return loggedOut;    
//         } catch (error) {
//             let message = error.response.data.error;
//             return thunkAPI.rejectWithValue(message);
//         }
//     }
// );
const authSlice = createSlice({
    name:'credObj',
    initialState,
    reducers:{
        toggleSideBar:(state) => {
            state.isSideBarOpen = !state.isSideBarOpen;
        },
        logoutUser: (state) => {
            state.credObj = null;
            state.isSideBarOpen = false;
            removeCredObjsFromLocalStorage();
        }
    },
    extraReducers: {
        [registerUser.pending]:(state) => {
            state.isLoading = true;
        },
        [registerUser.fulfilled]:(state, {payload}) => {
            const { token, refreshToken } = payload;
            const credObj = {
                token,
                refreshToken
            };
            state.isLoading = false;
            state.credObj = credObj;
            toast.success("Registration successfull!");
        },
        [registerUser.rejected]:(state, {payload}) => {
            state.isLoading = false;
            errorHandler(payload);
        },
        [loginUser.pending]:(state) => {
            state.isLoading = true;
        },
        [loginUser.fulfilled]:(state, {payload}) => {
            const { token, refreshToken } = payload;
            const credObj = {
                token,
                refreshToken
            };
            state.isLoading = false;
            state.credObj = credObj;
            addCredObjToLocalStorage(credObj);
            toast.success("Login Successfull");
        },
        [loginUser.rejected]:(state, {payload}) =>  {
            state.isLoading = false;
            errorHandler(payload);
        }
    }
});
export const { toggleSideBar, logoutUser } = authSlice.actions;
export default authSlice.reducer;